import React from "react";
// import { withRouter } from "react-router-dom";
import styles from "./HeroVideo.css";
import HeroVideoPlayer from "../partials/HeroVideoPlayer";
import CTAs from "../partials/CTAs";

const HeroVideo = ({ currentRoute, data }) => {
  const {
    header_bold,
    header_light,
    header_sub,
    cta_primary,
    cta_secondary,
    video,
    colors,
    image_no_cropping,
  } = data;

  return (
    <section className={styles.HeroVideoWrapper}>
      <HeroVideoPlayer video={video} />
      <div className={styles["HeroVideoWrapper-Content"]}>
        <div className={styles.HeroVideo}>
          <div className={styles["HeroVideo-Content"]}>
            <h1
              className={styles.Title}
              style={{ color: colors.foreground }}
              dangerouslySetInnerHTML={{ __html: header_bold }}
            />

            {header_light && (
              <h2
                className={styles.SubTitle}
                style={{ color: colors.foreground }}
                dangerouslySetInnerHTML={{ __html: header_light }}
              />
            )}

            <div className="row">
              <div
                className={`col-xs-11 ${!image_no_cropping ? "col-md-5" : ""}`}
              >
                <CTAs
                  cta_primary={cta_primary}
                  cta_secondary={cta_secondary}
                  cta_title={header_bold}
                />
              </div>
            </div>
          </div>
          {/* <div
            className={styles["HeroVideo-Footer"]}
            style={{
              color: colors.foreground,
              backgroundColor: colors.background,
            }}
          >
            <div className={styles.Footer}>
              <div
                className={[
                  styles.FooterContent,
                  styles["Footer-Content"],
                ].join(" ")}
              >
                <div className={styles["FooterContent-Light"]}>
                  {header_light}
                </div>
                <div className={styles["FooterContent-Sub"]}>{header_sub}</div>
              </div>
              <div className={styles["Footer-Action"]}>
                <Link to={cta_secondary.url} className="button secondary">
                  {cta_secondary.label}
                </Link>
                <Link to={cta_primary.url} className="button primary">
                  {cta_primary.label}
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default HeroVideo;



// WEBPACK FOOTER //
// ./src/components/Hero/HeroVideo/HeroVideo.js